import { create } from 'zustand'

import { getSessionStorage } from '@utils/states/sessionStorage'
import { getCompetenceDate, getUserPermissions, getPagePermissions } from './provider'

import type { UserDataProps, UseUserProps } from './types'

export const useUser = create<UseUserProps>((set) => ({
  filiData: null,
  setFiliData: (value) => set({ filiData: value }),

  userData: getSessionStorage<UserDataProps>('@SMARTOPS_USER_DATA') || null,
  setUserData: (value) => set({ userData: value }),

  competenceDateData: [],
  setCompetenceDateData: (value) => set({ competenceDateData: value }),

  isCompetenceDateLoading: false,
  setIsCompetenceDateLoading: (value) => set({ isCompetenceDateLoading: value }),

  userPermissionsData: null,
  setUserPermissionsData: (value) => set({ userPermissionsData: value }),

  isUserPermissionsLoading: false,
  setIsUserPermissionsLoading: (value) => set({ isUserPermissionsLoading: value }),

  getCompetenceDate,
  getUserPermissions,
  getPagePermissions
}))
